<script setup>

    import { ExclamationTriangleIcon } from '@heroicons/vue/20/solid'

    const props = defineProps({
        theme: {
            type: String,
            required: false,
            default: 'green' // 'blue', 'red', 'green', 'orange'
        }
    })

    const themeClasses = {
        green: 'bg-white *:bg-lifeworx-green-500/10 *:border-lifeworx-green-500/50 text-lifeworx-green-500',
        blue: 'bg-white *:bg-lifeworx-blue-600/10 *:border-lifeworx-blue-600/50 text-lifeworx-blue-600',
        red: 'bg-white *:bg-lifeworx-red-500/10 *:border-lifeworx-red-500/50 text-lifeworx-red-500',
        orange: 'bg-white *:bg-lifeworx-orange-600/10 *:border-lifeworx-orange-600/50 text-lifeworx-orange-600',
    }

</script>

<template>

    <div
        :class="`my-6 rounded-md ${themeClasses[props.theme]} `"
        role="alert"
    >
        <div class="p-4 rounded-md border-2 border-dashed">
            <div class="md:flex md:items-center">
                <div class="shrink-0">
                    <slot name="icon">
                        <ExclamationTriangleIcon class="size-7" aria-hidden="true" />
                    </slot>
                </div>

                <h3 class="ml-2 md:flex-grow font-bold">
                    <slot>Announcement</slot>
                </h3>
                <p class="font-semibold text-sm">
                    <slot name="body" />
                </p>
            </div>
        </div>
    </div>

</template>
